import { render, staticRenderFns } from "./WSectorAdd.vue?vue&type=template&id=bb4f4136&"
import script from "./WSectorAdd.vue?vue&type=script&lang=ts&"
export * from "./WSectorAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports